import React from "react";

export default function SidebarWidget() {
  return (
    <div
     >
    </div>
  );
}
